"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.work = exports.phoneNumberConfig = exports.mobile = exports.home = exports.PhoneNumberDisplayDefinition = exports.PhoneNumberDefinition = void 0;

var _types = require("../../types");

var _config = require("../config");

var _fieldDefinitionTypes = require("../../fields/config/fieldDefinitionTypes");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var TelephoneFieldDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.TelephoneFieldDefinition;
});

var ComponentConfigDefinition = _flowRuntime["default"].tdz(function () {
  return _config.ComponentConfigDefinition;
});

var ComponentElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.ComponentElementDefinition;
});

var home = {
  inputMode: 'numeric',
  key: 'home',
  maxLength: 100,
  normalize: 'number',
  pattern: '[0-9]*',
  label: 'Home phone number',
  type: 'tel',
  validation: [{
    ukLandlineNumber: true
  }]
};
exports.home = home;
var mobile = {
  inputMode: 'numeric',
  key: 'mobile',
  maxLength: 100,
  normalize: 'number',
  pattern: '[0-9]*',
  label: 'Mobile phone number',
  type: 'tel',
  validation: [{
    ukMobileNumber: true
  }]
};
exports.mobile = mobile;
var work = {
  inputMode: 'numeric',
  key: 'work',
  maxLength: 100,
  normalize: 'number',
  pattern: '[0-9]*',
  label: 'Work phone number',
  type: 'tel',
  validation: [{
    phoneNumber: true
  }]
};
exports.work = work;
var phoneNumberConfig = {
  type: 'phoneNumber',
  fields: [home, mobile, work],
  validation: []
};
exports.phoneNumberConfig = phoneNumberConfig;

var PhoneNumberDefinition = _flowRuntime["default"].type("PhoneNumberDefinition", _flowRuntime["default"].spread(_flowRuntime["default"].ref(ComponentElementDefinition), _flowRuntime["default"].object(_flowRuntime["default"].property("type", _flowRuntime["default"].string("phoneNumber")), _flowRuntime["default"].property("options", _flowRuntime["default"].object(_flowRuntime["default"].property("home", _flowRuntime["default"]["boolean"](), true), _flowRuntime["default"].property("mobile", _flowRuntime["default"]["boolean"](), true), _flowRuntime["default"].property("work", _flowRuntime["default"]["boolean"](), true)), true))));

exports.PhoneNumberDefinition = PhoneNumberDefinition;

var PhoneNumberDisplayDefinition = _flowRuntime["default"].type("PhoneNumberDisplayDefinition", _flowRuntime["default"].exactObject(_flowRuntime["default"].property("displayed", _flowRuntime["default"]["boolean"]()), _flowRuntime["default"].property("home", _flowRuntime["default"]["boolean"](), true), _flowRuntime["default"].property("mobile", _flowRuntime["default"]["boolean"](), true), _flowRuntime["default"].property("work", _flowRuntime["default"]["boolean"](), true)));

exports.PhoneNumberDisplayDefinition = PhoneNumberDisplayDefinition;